import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import tippy, { hideAll, inlinePositioning } from 'tippy.js';

export const dropdown = () => {
  Alpine.data('dropdown', () => ({
    open: false,
    tippyInstance: false,

    init() {
      this.dropdownElement = this.$el;
      this.dropdownButton = this.dropdownElement.querySelector('.a-dropdown__button');
      this.dropdownContent = this.dropdownElement.querySelector('.a-dropdown__content');
      this.createDropdown();
    },
    createDropdown() {
      if (this.dropdownContent) {
        this.tippyInstance = tippy(this.dropdownElement, {
          content: this.dropdownContent,
          arrow: true,
          trigger: 'click',
          triggerTarget: [this.dropdownButton],
          interactive: true,
          allowHTML: true,
          duration: [250, 150],
          inertia: true,
          animation: 'scale',
          placement: 'bottom-start',
          moveTransition: 'transform 0.2s ease-out',
          popperOptions: {
            modifiers: [
              {
                name: 'flip',
                options: {
                  fallbackPlacements: ['bottom', 'top'],
                },
              },
            ],
          },
          plugins: [this.accessibleToggle, inlinePositioning],
        });

        this.tippyInstance.props.onShow = () => {
          this.open = true;
        };

        this.tippyInstance.props.onHide = () => {
          this.open = false;
        };
      }
    },
    accessibleToggle: {
      name: 'accessibleToggle',
      defaultValue: true,
      fn(instance) {
        const { state, show, hide, props } = instance;

        function toggle() {
          return state.isVisible ? hide() : show();
        }

        function globalKeyDown(event) {
          if (event.keyCode === 27) {
            event.preventDefault();
            hide();
          }
        }

        function onKeyDown(event) {
          const triggerElement = props.triggerTarget;
          if (document.activeElement === triggerElement[0]) {
            if ([13, 32].includes(event.keyCode)) {
              event.preventDefault();
              toggle();
            }
          }
        }

        return {
          onCreate(tippyInstance) {
            document.addEventListener('keydown', globalKeyDown);
            tippyInstance.reference.addEventListener('keydown', onKeyDown);
          },
          onDestroy(tippyInstance) {
            document.removeEventListener('keydown', globalKeyDown);
            tippyInstance.reference.removeEventListener('keydown', onKeyDown);
          },
          onShow(tippyInstance) {
            hideAll({ exclude: tippyInstance });
          },
        };
      },
    },
    bindDropdownIcon: {
      // eslint-disable-next-line func-names
      ':class': function () {
        return {
          'rotate-180': this.open,
        };
      },
    },
  }));
};
